import { imageModel } from "./defaults";

export const ideogram4 = imageModel("ideogram-4", "Ideogram 4.0", {
  text: "ideogram/v4.0",
});
